import { z } from 'zod';
import { localeSchema } from './common';

export const assessmentSchema = z.object({
  goal: z.enum(['fat_loss', 'toning', 'strength', 'health']).optional(),
  activity: z.enum(['sedentary', 'moderate', 'active', 'very_active']).optional(),
  heightCm: z.number().int().min(100).max(250).optional(),
  weightKg: z.number().min(30).max(300).optional(),
  age: z.number().int().min(14).max(100).optional(),
  gender: z.enum(['female', 'male', 'other']).optional(),
  recommendedProductSlug: z.string().optional(),
});

export const contactInput = z.object({
  name: z.string().min(2).max(120),
  email: z.string().email().toLowerCase().trim(),
  phone: z.string().max(40).optional(),
  message: z.string().max(4000).optional(),
  source: z.enum(['contact_form', 'assessment', 'other']).default('contact_form'),
  assessment: assessmentSchema.optional(),
  locale: localeSchema.default('hr'),
  /** Honeypot — ako je popunjeno, zahtjev je bot. Vraćamo 200 i ne spremamo. */
  website: z.string().max(0).optional(),
});

export type ContactInput = z.infer<typeof contactInput>;
export type Assessment = z.infer<typeof assessmentSchema>;
